import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Layout from '../Layout/Layout';
import { endpoint } from '../../pages';

interface ErrorDisplayProps {
    error: string;
    title?: string;
    showHomeButton?: boolean;
}

/**
 * Specialized component for displaying error states
 * Provides consistent error UI across the application
 */
export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, title, showHomeButton = true }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Layout>
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="80vh">
                <Typography variant="h5" color="error">
                    {title || t('error_dialog_title') || 'Error'}
                </Typography>
                <Typography color="error" sx={{ mt: 2, textAlign: 'center', maxWidth: '600px' }}>
                    {error}
                </Typography>
                {showHomeButton && (
                    <Button onClick={() => navigate(endpoint.home)} variant="contained" sx={{ mt: 3 }}>
                        {t('go_to_home') || 'Go to Home'}
                    </Button>
                )}
            </Box>
        </Layout>
    );
};
